import { useRxCollection } from 'rxdb-hooks'

import type { Card } from '~/db/types'

import { LinearSlideAnimation } from '../linear-slide-animation'

import { useCardsReplication } from './hooks'

export const Replication = () => {
  const cardsCollection = useRxCollection<Card>('cards')
  const isSyncing = useCardsReplication(cardsCollection)

  return (
    <div className="absolute left-0 right-0 h-1 w-full">
      <LinearSlideAnimation className="h-1" isLoading={isSyncing} />
    </div>
  )
}
